import { resource } from 'redux-and-the-rest';

import Env from '../../utils/env';
import { PasswordResetModel } from '../../models/passwordResetModel';

const url = `${Env.API_URL}/users/password_reset/:id?`;

const {
  reducers: passwordResetReducer,
  getItem: getPasswordReset,
  clearItem: clearPasswordReset,
  createItem: createPasswordReset,
  updateItem: updatePassword,
  validateToken,
} = resource<PasswordResetModel>(
  {
    name: 'passwordResets',
    url,
    keyBy: 'id',
  }, {
    clearItem: true,
    createItem: true,
    getItem: true,
    fetchItem: true,
    updateItem: true,
    validateToken: {
      actionCreator: 'createItem',
      url: `${Env.API_URL}/users/password_reset`,

    },
  },
);

export {
  passwordResetReducer,
  getPasswordReset,
  createPasswordReset,
  clearPasswordReset,
  updatePassword,
  validateToken,
};
